module.exports = __webpack_public_path__ + "img/point-3.2d3c4408.png";